<template>
  <div class="lg:mb-12 md:mb-12 mt-4 lg:py-12 md:py-12 lg:mt-32">
    <!-- <PopupNeedHelp
      :isActive="isDetailsActive"
      :selectedNeedHelp="selectedNeedHelp"
      @close="toggleDetails"
    /> -->
    <div class="">
      <div class="lg:flex md:flex justify-center lg:pt-0 md:pt-0 pt-12">
        <div
          class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 rounded-2xl lg:w-auto md:w-auto w-3/5 m-auto"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p class="font-semibold text-black fsize20 sm-fsize14">
                Do you know someone
                <br />
                who need help?
              </p>
              <div
                class="lg:pl-14 md:pl-14 lg:pt-0 md:pt-0 pt-4 items-center flex lg:justify-start md:justify-start justify-center"
              >
                <base-button
                  type="primary"
                  class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                  @click="handleClick('community')"
                  >Know More
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import WhyUs from "./WhyUs";
// import PopupNeedHelp from "./PopupNeedHelp.vue";
export default {
  components: {
    // PopupNeedHelp,
    // WhyUs,
  },
  data() {
    return {
      selectedNeedHelp: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          text: "Dementia",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. It can be of various kinds, Alzheimer’s being the most common one. Family caregivers of people with dementia are important to the quality of the patient’s life. The effects of being a long-term caregiver often includes psychological burden and social isolation. Our community, support groups and counselling offer you the time and space to share your experiences and unburden your closed emotions.",
        },
        {
          id: "02",
          text: "Cancer",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
          description:
            "Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care and home-based care offers you opportunities to create checks and balances for your long-term caregiving needs.",
        },
        {
          id: "03",
          text: "ALS",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
          description:
            "Amyotrophic Lateral Sclerosis or ALS is a neurodegenerative disorder that progressively leads to loss of voluntary muscle movements. Currently, there is no cure for ALS, and neither any effective treatment to halt or reverse the progression of the disease. Informal caregiving for a loved one with ALS can be physically and mentally stressful. Our educational resources and learning programmes can equip you with better knowledge and skills to provide effective caregiving. Simultaneously, our support services enable you to focus on your well-being.",
        },
        {
          id: "04",
          text: "Mental Illness",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
          description:
            "Mental Illness refers to a wide range of mental health disorders that affect one’s mood, thinking and behaviour. Some common illnesses are depression, schizophrenia, and addiction. Primary caregivers of people with mental illnesses must bear with extreme behavioural disturbances which can cause considerable distress and anxiety. We help you cope with these circumstances through community support, guidance, and counselling services.",
        },
      ],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedNeedHelp = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
